/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetTrimSignatureImageItemDto } from './GetTrimSignatureImageItemDto';
import {
    GetTrimSignatureImageItemDtoFromJSON,
    GetTrimSignatureImageItemDtoFromJSONTyped,
    GetTrimSignatureImageItemDtoToJSON,
} from './GetTrimSignatureImageItemDto';

/**
 * 
 * @export
 * @interface GetTrimSignatureImagesDto
 */
export interface GetTrimSignatureImagesDto {
    /**
     * 
     * @type {boolean}
     * @memberof GetTrimSignatureImagesDto
     */
    dryRun: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetTrimSignatureImagesDto
     */
    trimmedCount: number;
    /**
     * 
     * @type {Array<GetTrimSignatureImageItemDto>}
     * @memberof GetTrimSignatureImagesDto
     */
    items: Array<GetTrimSignatureImageItemDto>;
}

/**
 * Check if a given object implements the GetTrimSignatureImagesDto interface.
 */
export function instanceOfGetTrimSignatureImagesDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "dryRun" in value;
    isInstance = isInstance && "trimmedCount" in value;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

export function GetTrimSignatureImagesDtoFromJSON(json: any): GetTrimSignatureImagesDto {
    return GetTrimSignatureImagesDtoFromJSONTyped(json, false);
}

export function GetTrimSignatureImagesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTrimSignatureImagesDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dryRun': json['dryRun'],
        'trimmedCount': json['trimmedCount'],
        'items': ((json['items'] as Array<any>).map(GetTrimSignatureImageItemDtoFromJSON)),
    };
}

export function GetTrimSignatureImagesDtoToJSON(value?: GetTrimSignatureImagesDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dryRun': value.dryRun,
        'trimmedCount': value.trimmedCount,
        'items': ((value.items as Array<any>).map(GetTrimSignatureImageItemDtoToJSON)),
    };
}

